import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';

import { FiltersControlBaseComponent } from '../filters-control-base/filters-control-base.component';
import { ProductModel, ProductsService } from '../../../products';
import { getProductSearchValue } from '../../../rnpl-common/helpers';
import { ProductTypes } from '../../../products/product-types';
import { AppState } from 'projects/workspace/src/app/store/state/app.state';
import { selectCompanyProfile } from 'projects/workspace/src/app/administration/store/selectors';
import { CompanyProfile } from 'projects/workspace/src/app/administration/models/company-profile.model';

@Component({
  selector: 'rnpl-filters-control-product',
  templateUrl: './filters-control-product.component.html',
})
export class FiltersControlProductComponent extends FiltersControlBaseComponent implements OnInit {

  @Input() availableProductTypes: ProductTypes[];

  public companyProfile: CompanyProfile;
  public defaultAvailableProductTypes = [ProductTypes.GOODS, ProductTypes.SERVICES, ProductTypes.DIGITAL];
  public productsList: ProductModel[] = [];
  public productTypes = ProductTypes;

  readonly showDropdownSpin$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private productsService: ProductsService,
    public translateService: TranslateService,
    private readonly store: Store<AppState>
  ) {
    super(translateService);

    this.store.select(selectCompanyProfile)
      .pipe(takeUntil(this.destroy$))
      .subscribe((profile: CompanyProfile) => this.companyProfile = profile);
  }

  ngOnInit() {
    this.getProducts();
  }

  private getProducts(): void {
    this.showDropdownSpin$.next(true);
    this.productsService.getActiveProducts()
      .pipe(
        finalize(() => this.showDropdownSpin$.next(false)),
        takeUntil(this.destroy$)
      )
      .subscribe((products: ProductModel[]) => {
        this.productsList = this.prepareProductsList(products);
      });
  }

  public prepareProductsList(products): ProductModel[] {
    return products
      .filter(item => (
        this.availableProductTypes
          ? !!this.availableProductTypes.includes(item.type)
          : !!this.defaultAvailableProductTypes.includes(item.type)
      ))
      .map(item => ({
        ...item,
        searchLabel: getProductSearchValue(item, this.translateService)
      }));
  }

}
